// state
const state = () => ({
  fields: [],
  noteId: 0
});

// getters
const getters = {};

// actions
const actions = {
  initFields({ commit }, fields) {
    commit('initFields', fields);
  },
};

// mutations
const mutations = {
  initFields(state, initFields) {
    state.fields = initFields;
  },
  updateNoteId(state, newNoteId) {
    state.noteId = newNoteId;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/customer-note.js